/**
 * @fileoverview 認証コレクション collection
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
// Collection Import
import CommonCollection from './CommonCollection';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import ConnectionUtil from '../util/ConnectionUtil';

/**
 * 認証コレクション
 *
 * @class AuthenticationCollection
 * @extends {CommonCollection}
 */
class AuthenticationCollection extends CommonCollection {
  /**
   * Creates an instance of AuthenticationCollection.
   * @memberof AuthenticationCollection
   */
  constructor() {
    super();
  }

  /**
   *  ログアウト
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof AuthenticationCollection
   */
  logout(callback, payload) {
    this.logoutCallback = callback;
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    let self = this;
    ConnectionUtil.callAPI(
      ConstUtil.Common.API_LIST.A02,
      request,
      ConstUtil.Common.TIMEOUT.DEFAULT,
      function(err, res) {
        if (err) {
          self.logoutCallback.failure(err);
          return;
        }
        self.logoutCallback.success();
        return;
      }
    );
  }
}
export default AuthenticationCollection;



// WEBPACK FOOTER //
// ./src/js/collection/AuthenticationCollection.jsx